import { Component, Input } from '@angular/core';
import { CurrencyFormatInfo } from '@sb/library/data-models';
import { LocalizationCurrencyNoSymbolPipe, LocalizationCurrencyPipe } from '@sb/library/localization';
import { FormFieldNumberComponent } from '../number/form-field-number.component';

@Component({
    selector: 'lib-input-currency',
    templateUrl: './form-field-currency.component.html',
    styleUrls: ['./form-field-currency.component.scss']
})
export class FormFieldCurrencyComponent extends FormFieldNumberComponent {
    @Input() override minDecimalPlaces: number = this._LocalizationService.CurrencyFormatInfo.DecimalDigits;
    @Input() override maxDecimalPlaces: number = this._LocalizationService.CurrencyFormatInfo.DecimalDigits;

    private _CurrencyFormatInfo!: CurrencyFormatInfo;

    private _currencyPattern = '¤ n';
    private _regexCurrencySymbolPlacement = /^n/;
    private _currencySymbolRightPlacement = false;
    private _currencyFormatter!: LocalizationCurrencyNoSymbolPipe;

    constructor() {
        super();

        this._CurrencyFormatInfo = this._LocalizationService.CurrencyFormatInfo;
        this._NumberFormatInfo = this._LocalizationService.CurrencyFormatInfo;
        this._currencyFormatter = new LocalizationCurrencyNoSymbolPipe();

        let formatter = new LocalizationCurrencyPipe();
        this.errors.Override({
            min: (value: {min: number, actual: number}) =>
                $localize`:@@CommonCurrencyValueTooSmallInclusive:Please enter an amount greater than or equal to ${formatter.transform(value.min, this.minDecimalPlaces, this.maxDecimalPlaces)}.`,
            minExclusive: (value: {min: number, actual: number}) =>
                $localize`:@@CommonCurrencyValueTooSmallExclusive:Please enter an amount greater than ${formatter.transform(value.min, this.minDecimalPlaces, this.maxDecimalPlaces)}.`,
            max: (value: {max: number, actual: number}) =>
                $localize`:@@CommonCurrencyValueTooLargeInclusive:Please enter an amount less than or equal to ${formatter.transform(value.max, this.minDecimalPlaces, this.maxDecimalPlaces)}.`,
            maxExclusive: (value: {max: number, actual: number}) =>
                $localize`:@@CommonCurrencyValueTooLargeExclusive:Please enter an amount less than ${formatter.transform(value.max, this.minDecimalPlaces, this.maxDecimalPlaces)}.`
        });

        this.GetCurrencySymbolPlacement();
    }

    override ngOnInit() {
        super.ngOnInit();

        this.GetRegexForValidation();
    }

    private GetRegexForValidation(): void {
        let decimalSeparator = this._CurrencyFormatInfo.DecimalSeparator;

        //Follow this format ^(\d+)(\.\d{0,4})?$
        let decimalRegex: string;
        if (this.maxDecimalPlaces > 0) {
            decimalRegex = `^(\\d+([${decimalSeparator}]\\d{0,${this.maxDecimalPlaces}})?|[${decimalSeparator}]\\d{0,${this.maxDecimalPlaces}})$`;
        } else {
            decimalRegex = `^(\\d+)$`;
        }

        this._validationRegex = new RegExp(decimalRegex, 'g');
    }

    override ValueFormatter(numberValue: number): string {
        return this._currencyFormatter.transform(numberValue, this.minDecimalPlaces, this.maxDecimalPlaces);
    }

    private GetCurrencySymbolPlacement(): void {
        this._currencyPattern = this._CurrencyFormatInfo.PositivePattern!.trim();
        this._currencySymbolRightPlacement = this._regexCurrencySymbolPlacement.test(this._currencyPattern);
    }

    get currencySymbolRightPlacement(): boolean {
        return this._currencySymbolRightPlacement;
    }

    get currencySymbol(): string {
        return this._CurrencyFormatInfo.CurrencySymbol!;
    }
}
